
export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/eb8ff83a3546fe57070bf812bafc35d3.jfif"
              alt="ZOLLER"
              className="h-10 w-auto"
            />
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <a href="#solution" className="text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer">
              ソリューション
            </a>
            <a href="#benefits" className="text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer">
              導入効果
            </a>
            <a href="#roi" className="text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer">
              ROI計算
            </a>
            <a href="#cases" className="text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer">
              導入事例
            </a>
            <a href="#contact" className="text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer">
              お問い合わせ
            </a>
          </nav>

          <div className="flex items-center space-x-4">
            <button className="bg-yellow-500 text-gray-900 px-4 py-2 rounded-lg hover:bg-yellow-600 transition-colors whitespace-nowrap cursor-pointer font-semibold">
              資料請求
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}